module.exports = __webpack_public_path__ + "static/media/right-icon.9b946edb.svg";